import react, {useRef, useState, useEffect, useCallback} from 'react';
import {Row, Card, Col, Empty, Pagination, message, Spin, Tooltip, Drawer, Button, Modal, Input, Select} from 'antd';
import styles from './index.module.less';
import {modalBindingKjlAccountModelFn} from './bindingKuklerAccountModel';
import {ModalBindingKuklerSchemesDetailsModelDom} from './bindingKuklerSchemeDetailsModel';
import dayjs from "dayjs";
import {SBack, SDrawerOrModal, SMessage, SSearchForm} from "shj-components";
import {
  dcpBizOpDesignRelBindBizOp,
  dcpBizOpDesignRelListBizOpDesignInfo,
  dcpDesignInfoSearchKjl
} from "@/services/kuAccount.ts";
import _ from "lodash-es";
import {useParams} from "react-router-dom";
import {FormSelect, FormText} from "shj-components/dist/es/SSearchForm/Formrender";

export const KjlManager = (props: any) => {
  const id = useParams()?.id || props?.bizId;
  const searchForm = useRef<any>();
  const searchFormData = useRef<any>();
  const [searchData, setSearchData] = useState<any>({...searchForm?.current?.getFieldsValue()}); //搜索
  const [kjlSchemesList, setKjlSchemesList] = useState<any>([]); //酷家乐方案列表
  const [pagination, setPagination] = useState<any>({
    total: 0,
    current: 1,
    pageSize: 10,
  }); //分页
  const [loading, setLoading] = useState<any>(false); //分页
  // 获取基础数据
  const [confirmLoading, setConfirmLoading] = useState<any>(false); //提交
  // 获取基础数据
  const [visibleDrawer, setVisibleDrawer] = useState<any>(false); //抽屉
  const [bindedObj, setBindedObj] = useState<any>({}); //已绑定方案对象
  // 获取基础数据
  const [nowDetails, setNowDetails] = useState<any>({}); //当前详情
  // 获取基础数据
  const initFn = (pageData: any) => {
    const {current, pageSize} = pageData;
    const query = searchForm?.current?.getFieldsValue() || searchFormData.current;
    // console.log(11111111111111, query)
    if (!query?.kjlAccount) return;
    setLoading(true);
    dcpDesignInfoSearchKjl(current, pageSize, query)
        .then((data: any) => {
          const records = _.get(data, 'list', []);
          const total = _.get(data, 'count', 0);
          setKjlSchemesList(records);
          setPagination({
            ...pagination,
            ...pageData,
            total,
          });
          setLoading(false);
        })
        .catch(() => {
          setKjlSchemesList([]);
          setPagination({
            total: 0,
            current: 1,
            pageSize: 10,
          });
          setLoading(false);
        });
  };
  // 已绑定
  const bindedFn = () => {
    if (!id) return;
    dcpBizOpDesignRelListBizOpDesignInfo([id])
      .then((resp: any) => {
        const data = resp[id] || {};
        setBindedObj({
          ...data,
        });
      })
      .catch(() => {
        setBindedObj({});
      });
  };
  // 搜索
  const onSearchFinish = (value: any) => {
    setSearchData(value);
    searchFormData.current = value;
    if (!value.kjlAccount) return message.error('请先选择酷家乐账号再查询');
    setPagination({
      total: 0,
      current: 1,
      pageSize: 10,
    });
    initFn({
      total: 0,
      current: 1,
      pageSize: 10,
    });
    bindedFn();
  };
  // 重置
  const onSearchReset = () => {
    searchFormData.current = {};
    setSearchData({});
    setPagination({
      total: 0,
      current: 1,
      pageSize: 10,
    });
  };
  // 已绑定
  const bindDom = () => {
    return Object.keys(bindedObj).length > 0 ? (
        <Card size="small" bordered={false} bodyStyle={{padding: '0 0 10px 0'}}>
          <div className={styles.boundBox}>
            <div className={styles.leftBox}>已绑定方案</div>
            <div
                className={styles.rightBox}
                onClick={() => {
                  setNowDetails({...bindedObj});
                  setVisibleDrawer(true);
                }}
            >
              <div className={styles.imgBox}>
                <img src={bindedObj.planPic || bindedObj.designPanoUrl} alt={''}/>
                <span className={styles.txt1}>{bindedObj.status == 1 ? '装修阶段' : '户型阶段'}</span>
              </div>
              <div className={styles.imgTxt}>
                <Tooltip title={`${bindedObj.name}`}>
                  <div className={styles.txt1}>{bindedObj.name}</div>
                </Tooltip>
                <div className={styles.txt2}>{bindedObj.commName}</div>
                <div className={styles.txt3}>
                  <span>{bindedObj.planId ? '户型ID' : '方案ID'}</span>
                  {bindedObj.planId || bindedObj.designId}
                </div>
                <div className={styles.txt4}>
                  绑定时间：{bindedObj?.createdTime ? dayjs(bindedObj.createdTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                </div>
              </div>
            </div>
          </div>
        </Card>
    ) : null;
  };
  // 方案列表
  const schemeListDom = () => {
    return (
        <Card size="small" bordered={false} bodyStyle={{padding: '0 0 10px 0'}}>
          {searchData.kjlAccount ? (
              <div className={styles.schemeListBox}>
                {kjlSchemesList && kjlSchemesList.length > 0 ? (
                    <Spin spinning={loading} style={{color: '#666'}}>
                      <Row gutter={[12, 12]}>
                        {kjlSchemesList.map((item: any, index: number) => {
                          return (
                              <Col span={6} key={`${item.planId}-${item.designId}-${index}`}>
                                <div
                                    className={styles.schemeItemBox}
                                    onClick={() => {
                                      setNowDetails({...item});
                                      setVisibleDrawer(true);
                                    }}
                                >
                                  <div className={styles.imgBox}>
                                    <img src={item.planPic || item.designPanoUrl} alt={''}/>
                                    <div className={styles.txt1}>{item.status == 1 ? '装修阶段' : '户型阶段'}</div>
                                    {/*<div className={styles.txt2}>取消</div>*/}
                                    <div className={styles.txt2}>选择</div>
                                  </div>
                                  <div className={styles.imgTxt}>
                                    <Tooltip title={`${item.name}`}>
                                      <div className={styles.txt1}>{item.name}</div>
                                    </Tooltip>
                                    <div className={styles.txt2}>{item.commName}</div>
                                    <div className={styles.txt3}>
                                      <span>{bindedObj.planId ? '户型ID' : '方案ID'}</span>
                                      {bindedObj.planId || bindedObj.designId}
                                    </div>
                                  </div>
                                </div>
                              </Col>
                          );
                        })}
                      </Row>
                      <div className={styles.paginationBox}>
                        <Pagination
                            key="key"
                            size="small"
                            showSizeChanger
                            showQuickJumper
                            showTotal={() => `${pagination.total}条`}
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            hideOnSinglePage={false}
                            total={pagination.total}
                            onChange={(page, pageSize) => {
                              setPagination({
                                ...pagination,
                                current: page,
                                pageSize,
                              });
                              initFn({current: page, pageSize});
                            }}
                        />
                      </div>
                    </Spin>
                ) : (
                    <Spin spinning={loading} style={{color: '#666'}}>
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                      <div className={styles.paginationBox}>
                        <Pagination
                            key="key"
                            size="small"
                            showSizeChanger
                            showQuickJumper
                            showTotal={() => `${pagination.total}条`}
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            hideOnSinglePage={false}
                            total={pagination.total}
                            onChange={(page, pageSize) => {
                              setPagination({
                                ...pagination,
                                current: page,
                                pageSize,
                              });
                              initFn({current: page, pageSize});
                            }}
                        />
                      </div>
                    </Spin>
                )}
              </div>
          ) : (
              <Spin spinning={loading}>
                {' '}
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={'请先选择酷家乐账号再查询'}/>
              </Spin>
          )}
        </Card>
    );
  };

  // 方案详情
  const onCloseFn = () => {
    setVisibleDrawer(false);
  };
  // 绑定方案
  const onConfirmFn = () => {
    SMessage.confirm({
      title: `该需求是否确定绑定该酷家乐方案？`,
      content: null,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        const {appuid, designId, planId} = nowDetails;
        const submitObj: any = {
          bizOpId: id,
          appuid,
        };
        if (designId) {
          submitObj.designId = designId;
          submitObj.planId = '';
        } else {
          submitObj.planId = planId;
        }
        setConfirmLoading(true);
        dcpBizOpDesignRelBindBizOp({...submitObj})
          .then((data: any) => {
            bindedFn();
            setVisibleDrawer(false);
            setConfirmLoading(false);
            data?.message && message.success(data?.message);
            console.log('resp', data);
          })
          .catch(() => {
            setVisibleDrawer(false);
            setConfirmLoading(false);
          });
      },
    });
  };

  useEffect(() => {
    initFn(pagination);
    return () => {
    };
  }, []);

  useEffect(() => {
    bindedFn();
  }, [id]);

  const onClear = () => {
    const form = searchForm?.current;
    const obj_ = {kjlAccount: '', kjlName: '', appuid: ''};
    form?.setFieldsValue(obj_);
    setSearchData({
      ...searchData,
      ...obj_,
    });
    searchFormData.current = {
      ...searchData,
      ...obj_,
    };
    setKjlSchemesList([]);
  }

  const onSelect = () => {
    modalBindingKjlAccountModelFn({
      fn: (selectedRowsObj: any) => {
        const form = searchForm?.current;
        const {kjlAccount, kjlName, appuid} = selectedRowsObj;
        form?.setFieldsValue({
          kjlAccount,
          kjlName,
          appuid,
        });
        setSearchData({
          ...searchData,
          kjlAccount,
          kjlName,
          appuid,
        });
        searchFormData.current = {
          ...searchData,
          kjlAccount,
          kjlName,
          appuid,
        }
        setKjlSchemesList([]);
      },
    });
  }

  const searchConfig = {
    events: {onClear, onSelect},
    customRender: {
       searchRender(){
           return <Input placeholder={'请点击选择'} onClick={() => {
           modalBindingKjlAccountModelFn({
             fn: (selectedRowsObj: any) => {
               const form = searchForm?.current;
               const { kjlAccount, kjlName, appuid } = selectedRowsObj;
               form?.setFieldsValue({
                 kjlAccount,
                 kjlName,
                 appuid,
               });
               setSearchData({
                 ...searchData,
                 kjlAccount,
                 kjlName,
                 appuid,
               });
               setKjlSchemesList([]);
             },
           });
         }}/>
       }
    },
    columns: [
      {
        name: 'kjlAccount',
        label: '酷家乐账号',
        itemType: 'custom',
        render: 'searchRender',
        allowClear: true,
        showSearch: true,
        events: ['onClear:onClear', 'onClick: onSelect']
      },
      {
        name: 'kjlName',
        label: '酷家乐账号名称',
        disabled: true
      },
      {
        name: 'appuid',
        label: '关联生活家账号',
        disabled: true
      },
      {
        name: 'keyword',
        label: '关键词',
      },
      {
        name: 'status',
        label: '方案阶段',
        itemType: 'select',
        labelKey: 'title',
        key: 'code',
        data: [
                { title: '户型阶段', code: 0, },
                { title: '装修阶段', code: 1, },
              ]
      },
    ]
  }

  return (
      <SBack level={2} title={'绑定酷家乐方案'}>
        <Card size="small" bordered={false} className={styles.mt10}>
          <SSearchForm
              onFinish={onSearchFinish}
              onReset={onSearchReset}
              fieldControl={false}
              formRef={searchForm}
              searchMode={'group'}
              initialValues={{status: 1}}
              {...searchConfig}
          />
        </Card>
        <Card
            size="small"
            title={
              <>
                <div className={styles.title}>数据列表</div>
              </>
            }
            bordered={false}
            bodyStyle={{padding: 10}}
        >
          {/*已绑定*/}
          {bindDom()}

          {/*方案列表*/}
          {schemeListDom()}
        </Card>
        <SDrawerOrModal
            bodyStyle={{padding: 10}}
            title="方案详情"
            onCancel={onCloseFn}
            open={visibleDrawer}
            antdProps={{
              footer: [!nowDetails?.id ? (
                  <div>
                    <Button htmlType="button" onClick={onCloseFn}>
                      取消
                    </Button>
                    <Button style={{marginLeft: 10}} type="primary" htmlType="submit" onClick={onConfirmFn} loading={confirmLoading}>
                      绑定
                    </Button>
                  </div>
              ) : null]
            }}
        >
          {/*className={`${style.bodyBox} ${style.hasFooter}`}*/}
          <div>
            <ModalBindingKuklerSchemesDetailsModelDom nowDetails={nowDetails}/>
          </div>
        </SDrawerOrModal>
      </SBack>
  );
};

export default (props: any) => {
  return <KjlManager {...props} />;
};
